import * as React from 'react';
import { EditComponent, CreateComponent, CustomComponentProps } from 'src/components/common/Component';

export function TagEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["name"]} children={children} />
    );
}

export function TagCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"tag"} children={children} />
    );
}